import { Person } from "@fartherfinance/frontend/api/Tasks/Types";

import { EnhancedAutocompleteOption, UNKNOWN_USER } from "./common";

export const mapPersonToOption = (
  person: Person
): EnhancedAutocompleteOption => {
  return {
    label: person.name
      ? `${person.name.first} ${person.name.last}`
      : UNKNOWN_USER,
    value: person.id,
  };
};

export const formatPersonName = (name: {
  prefix: "Dr" | "Mdm" | "Mr" | "Ms" | "Mrs" | "Miss" | "Sir" | "Prof" | null;
  first: string;
  middle: string | null;
  last: string;
  suffix: "II" | "III" | "IV" | "Jr" | "Sr" | null;
}): string => {
  const { prefix, first, middle, last, suffix } = name;
  const nameParts = [prefix, first, middle, last, suffix].filter(Boolean);
  return nameParts.join(" ");
};
